import React from "react";
import { Close } from "@mui/icons-material";
import { Box, DialogTitle, IconButton, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import {
  mergeSeeditDialogSx,
  seeditDialogCloseIconButtonSx,
  seeditDialogHeaderRowSx,
  seeditDialogTitleSx
} from "./dialog-layout.styles";

type P = {
  title: React.ReactNode;
  onClose: () => void;
  closeAriaLabel?: string;
  closeTestId?: string;
  titleId?: string;
  titleVariant?: "h6" | "subtitle1";
  sx?: SxProps<Theme>;
};

export const DialogHeaderWithClose: React.FC<P> = ({
  title,
  onClose,
  closeAriaLabel,
  closeTestId,
  titleId,
  titleVariant = "h6",
  sx
}) => {
  const { t } = useTranslation();

  return (
    <DialogTitle id={titleId} sx={mergeSeeditDialogSx(seeditDialogTitleSx, sx)}>
      <Box sx={seeditDialogHeaderRowSx}>
        {typeof title === "string" ? (
          <Typography component="span" variant={titleVariant}>
            {title}
          </Typography>
        ) : (
          title
        )}
        <IconButton
          aria-label={closeAriaLabel ?? t("Close")}
          onClick={onClose}
          size="small"
          data-testid={closeTestId}
          sx={seeditDialogCloseIconButtonSx}
        >
          <Close />
        </IconButton>
      </Box>
    </DialogTitle>
  );
};
